import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CardSetTransformationService, DialogService, CoreService, SpinnerService, DataService, SaveDataRequest, VerticalNavigationSettings, SaveFormEvent, FormHeaderModel, FormNavigationService, ElementType, DialogResult, Option } from 'dspx-core';
import { Subscription, bufferTime, filter, take } from 'rxjs';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { APP_DATA_KEYS, FORM_IDENTIFIERS, NAV_TAB_NUMBERS, OPTION_SETS, PAGE_NUMBERS, POP_UP_CODES, POP_UP_HEADER, POP_UP_TEXTS, QUESTION_CODES, SECTION_CODES, SERVER_ERROR_POP_UP_CODES } from 'src/app/constants/app-data.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from '../../services/response-parser.service';
import * as _ from 'lodash';
import { ConcessionsApplicationBaseComponent } from '../concessions-application-base-component/concessions-application-base-component';
import { Guid } from 'guid-typescript';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-concessions-application-non-mains-life-support.component.component',
  templateUrl: './concessions-application-non-mains-life-support.component.html',
  styleUrls: ['./concessions-application-non-mains-life-support.component.scss']
})
export class ConcessionsApplicationNonMainsLifeSupportComponent extends ConcessionsApplicationBaseComponent implements OnInit, OnDestroy {

  fieldTypeReplacements =
    CardSetTransformationService.cardSetFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;
  verticalNavigationSettings: VerticalNavigationSettings = { enabled: true, sticky: true, pageLevel: true, type: 'horizontal-stepper' };
  formNavSubscription: Subscription;

  private _previousTab: number = 1;
  private _previousPage: number = 1;
  private _currentTab: number = 1;
  private _currentPage: number = 1;

  templateId: number = TEMPLATES.concessionsApplicationnonMainsLifeSupport;
  versionNo: number = VERSIONS.latest;
  model: any;
  editing: boolean = false;
  primaryAddressIsManual: boolean = false;
  activeApplications: any;
  previousApplications: any;
  previousInvoiceNumbers: any;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected dialogService: DialogService,
    protected appDataService: AppDataService,
    protected responseParserService: ResponseParserService,
    protected spinnerService: SpinnerService,
    protected errorService: ErrorService,
    protected dataService: DataService,
    private coreService: CoreService,
    private formNavigationService: FormNavigationService,
    private viewportScroller: ViewportScroller
  ) {
    super(router, route, dataService, appDataService, responseParserService, dialogService, spinnerService, errorService);
  }

  ngOnInit(): void {
    this.formServiceEndpoint = API_ENDPOINT_KEYS.getConcessionsApplicationNonMainsLifeSupportConfigAndResponse;
    this.saveEndpoint = API_ENDPOINTS.concessionsApplicationNonMainsLifeSupport.save;

    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const id = paramMap.get('id');
        const personId = paramMap.get('personId');

        if (id) {
          this.id = id;
          this.editing = true;
        } else if (personId) {
          this.id = `${Guid.EMPTY}/${personId}`
          this.personId = personId;
        }
        else {
          this.resetDirtyFlagAfterLoading();
        }
      })
    );

    this.coreService.conditionFunctions = {
      isEditing: () => this.editing,
      isPrimaryAddressManual: () => this.isPrimaryAddressManual(),
      isPrimaryAddressAuto: () => this.isPrimaryAddressAuto(),
      showCenterlinkCardDetails: () => this.showCenterlinkCardDetails(),
      showVeteransAffairsCardDetails: () => this.showVeteransAffairsCardDetails(),
      showPensionerCardIssuer: () => this.showPensionerCardIssuer(),
      patientPersonAddressesAreDifferent: () => this.patientPersonAddressesAreDifferent(),
      showUploadDocument: () => this.showUploadDocument(),
      exit: () => this.exit(),
      true: () => true,
      false: () => false,
      readOnly: () => true,
      showInvoiceElectricitySection: () => this.showInvoiceElectricitySection(),
      showStatDecUploadElectricity: () => this.showStatDecUploadElectricity(),
      showInvoiceUploadElectricity: () => this.showInvoiceUploadElectricity(),
      showInvoiceWaterSection: () => this.showInvoiceWaterSection(),
      showStatDecUploadWater: () => this.showStatDecUploadWater(),
      showInvoiceUploadWater: () => this.showInvoiceUploadWater(),
      isConsentNotAgree: () => this.isConsentNotAgree(),
      isConsentAgree: () => this.isConsentAgree(),
      isConsentNotsignedandNoConfirmation: () => this.isConsentNotsignedandNoConfirmation(),
      showSignedApplicationUpload: () => this.showSignedApplicationUpload(),
      isCustomerPortalApplication: () => this.isCustomerPortalApplication(),
      isStaffPortalApplication: () => this.isStaffPortalApplication(),
      addNewPostalAddress: () => this.addNewPostalAddress(),
      isReadOnly: () => this.isReadOnly(),
      showInstallPeritoneal: () => this.showInstallPeritoneal(),
      showInstallOxygen: () => this.showInstallOxygen(),
      showInstallHaemodialysis: () => this.showInstallHaemodialysis(),
      isEditOrStaffPortalApplication: () => true,
      isFirstNameReadonly: () => this.isFirstNameReadonly(),
      isLastNameReadonly: () => this.isLastNameReadonly(),
      isEmailReadonly: () => this.isEmailReadonly(),
      isMobilePhoneReadonly: () => this.isMobilePhoneReadonly(),
      isOtherPhoneReadonly: () => this.isOtherPhoneReadonly(),
      isDateOfBirthReadonly: () => this.isDateOfBirthReadonly(),
      isPrimaryAddressReadonly: () => this.isPrimaryAddressReadonly(),
      isPostalAddressSameAsPrimaryAddressReadonly: () => this.isPostalAddressSameAsPrimaryAddressReadonly(),
      isPostalAddressReadonly: () => this.isPostalAddressReadonly()
    }

    this.coreService.applicationFunctions = {
      exit: () => this.exit(),
      showInvoiceSectionHelp: () => this.showInvoiceSectionHelp(),
      fileUploadOnBeforeRemoveInvoice: (file: File, onComplete: (cancel: boolean) => void): void => this.fileUploadOnBeforeRemoveInvoice(file, onComplete),
      fileUploadOnBeforeRemoveInvoiceWater: (file: File, onComplete: (cancel: boolean) => void): void => this.fileUploadOnBeforeRemoveInvoiceWater(file, onComplete),

    }

    this.coreService.repeatingSectionFunctions = {
      onSaveInvoice: (itemIndex: number, onComplete: (cancel: boolean) => void): void => this.onSaveInvoice(itemIndex, onComplete),
      onSaveInvoiceWater: (itemIndex: number, onComplete: (cancel: boolean) => void): void => this.onSaveInvoiceWater(itemIndex, onComplete),
      onBeforeRemoveInvoice: (itemIndex, callback) => this.onBeforeRemoveInvoice(itemIndex, callback),
      onBeforeRemoveInvoiceWater: (itemIndex, callback) => this.onBeforeRemoveInvoiceWater(itemIndex, callback)
    };

    this.registerSaveOnNavigation();
  }

  fileUploadOnBeforeRemoveInvoice(file: any, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfo;
    const lookupValue = file.name + ":" + file.id;
    const invoice = invoiceInfo.find(invoice => invoice.invoiceDocument === lookupValue);

    if (invoice?.invoiceUploadedFromUserPortal) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    }
    else {
      onComplete(false);
    }
  }

  fileUploadOnBeforeRemoveInvoiceWater(file: any, onComplete: (cancel: boolean) => void): void {
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoWater;
    const lookupValue = file.name + ":" + file.id;
    const invoice = invoiceInfo.find(invoice => invoice.invoiceDocumentWater === lookupValue);

    if (invoice?.invoiceUploadedFromUserPortalWater) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    }
    else {
      onComplete(false);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.formNavSubscription.unsubscribe();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded($event) {
    if (this.baseForm && this.baseForm.model) {
      this.appDataService.setAppData(APP_DATA_KEYS.previousModel, JSON.parse(JSON.stringify(this.baseForm.model)));
    }
    super.formLoad($event);
    this.activeApplications = $event.activateApplications;
    this.previousApplications = $event.previousApplications;
    this.previousInvoiceNumbers = $event.previousInvoiceNumbers;
    this.formHeaderModel = $event.headerResponse;
    this.isPersonBothCarerAndConcessionsApplicant = $event.isPersonBothCarerAndConcessionsApplicant;
    this.isPersonWithActiveCareAllowancePlacements = $event.isPersonWithActiveCareAllowancePlacements;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.entitlementLetter] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsWaterForm.signedApplication] = FORM_IDENTIFIERS.concessionsFormIdentifier;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.patientUploadDocument] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.statDecDocument] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.patientUploadDocument] = FORM_IDENTIFIERS.concessionsFormIdentifier;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.invoiceDocument] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.statDecDocument] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.invoiceDocumentWater] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.statDecDocumentWater] = FORM_IDENTIFIERS.concessionsFormIdentifier;
  }

  home(event: any) {
    this.navigateBackToHome();
  }

  exit(){
    this.navigateBackToHome();
  }

  save(event: SaveFormEvent) {

    let saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (event.isSubmit) {
      if (event.isFormValid === false) {
        this.baseForm.markAllFieldsAsTouched();
        this.baseForm.showValidationSummary(true);
      }
      else {
        // submit application
        if (!this.showInvoiceWaterSection()) {
          let jsonData = JSON.parse(event.model);
          jsonData.form.tabs.tab5.page1.invoiceUploadWater = {};
          saveDataRequest.response = JSON.stringify(jsonData);
        }
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  cancel(event: any) {
    if (this.formNavigationService.currentTabIndex == 0 && this.formNavigationService.currentPageIndex == 0) {
      this.navigateToConcessionsInfo();
    } else {
      this.formNavigationService.moveBack();
    }
  }

  dialogSubmit(event: any): void {
    switch (this.activeDialog) {
      case POP_UP_CODES.concessionsApplicationCommon.submitSuccessful: {
        this.navigateBackToHome(true);
        break;
      }
    }
  }

  modelChange(event: any): void {
    if (this.baseForm?.model) {
      var addressSection = this.baseForm?.model?.form?.tabs?.tab2?.page1?.address;
      if (addressSection) {
        var value = addressSection[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.primaryAddressManualAddress];
        this.primaryAddressIsManual = (value === true);
      }

      let applicableYear = this.selectedApplyForYear?.split("to");
      if (applicableYear && applicableYear.length > 0) {
        this.baseForm.model.form.tabs.tab4.page1.machineDetails.applicableYear = "1st of July " + applicableYear[0];
      }

      this.UpdateHeaderAndApplicationPeriod();
    }
  }

  private UpdateHeaderAndApplicationPeriod() {
    let applicationPeriod = this.updateHeaderSubtitle(this.baseForm.optionSets.financialyear as Option[]);
    if (applicationPeriod) {
      this.baseForm.model.form.tabs.tab5.page1.invoiceUpload.applicationPeriod = applicationPeriod;
    }
  }

  isPrimaryAddressManual(): boolean {
    return this.primaryAddressIsManual;
  }

  isPrimaryAddressAuto(): boolean {
    return !this.primaryAddressIsManual;
  }

  showCenterlinkCardDetails(): boolean {
    //only displays if Card Type == 'Pensioner Concession Card' AND Pensioner Card Issuer = 'Centrelink' (selected as the issuer)
    //Or Card Type == 'Health Care Card'
    var cardType = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.cardType;
    var pensionerCardIssuer = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.pensionerCardIssuer;
    let centrelinkCardNumber = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.centrelinkCardNumber;

    let result = cardType === OPTION_SETS.concessionsCardType.options.healthCareCard ||
      (cardType === OPTION_SETS.concessionsCardType.options.pensionerConcessionCard &&
        pensionerCardIssuer === OPTION_SETS.pensionerCardIssuer.options.centrelink);

    // setting the Centrelink Card Number
    if (result === true && !centrelinkCardNumber) {
      let profileCentrelinkCardNumber = this.baseForm.model.form.tabs.tab2.page1?.profileCardDetails?.profileCentrelinkCardNumber;
      _.set(this.baseForm.model,
        ['form', 'tabs',
          'tab' + NAV_TAB_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.concessionsCard,
          'page' + PAGE_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.concessionsCard,
          SECTION_CODES.concessionsApplicationNonMainsLifeSupportForm.cardDetails,
          QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.centrelinkCardNumber],
        profileCentrelinkCardNumber);
    }

    return result
  }

  showVeteransAffairsCardDetails(): boolean {
    //only displays if 'Pensioner Concession Card' AND 'Veterans Affairs' (selected as the issuer)
    //OR 'Veterans Affairs Gold Card' selected on above question
    var cardType = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.cardType;
    var pensionerCardIssuer = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.pensionerCardIssuer;
    let veteransAffairsCardNumber = this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.veteransAffairsCardNumber;

    let result = cardType === OPTION_SETS.concessionsCardType.options.veteransAffairsGoldCard ||
      (cardType === OPTION_SETS.concessionsCardType.options.pensionerConcessionCard &&
        pensionerCardIssuer === OPTION_SETS.pensionerCardIssuer.options.veteransAffairs);

    // setting the Veterans Affairs File Number
    if (result === true && !veteransAffairsCardNumber) {
      let profileVeteransAffairsFileNumber = this.baseForm.model.form.tabs.tab2.page1?.profileCardDetails?.profileVeteransAffairsFileNumber;
      _.set(this.baseForm.model,
        ['form', 'tabs',
          'tab' + NAV_TAB_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.concessionsCard,
          'page' + PAGE_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.concessionsCard,
          SECTION_CODES.concessionsApplicationNonMainsLifeSupportForm.cardDetails,
          QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.veteransAffairsCardNumber],
        profileVeteransAffairsFileNumber);
    }

    return result
  }

  showPensionerCardIssuer(): boolean {
    return (this.baseForm?.model?.form?.tabs?.tab3?.page1?.cardDetails?.cardType === OPTION_SETS.concessionsCardType.options.pensionerConcessionCard);
  }

  patientPersonAddressesAreDifferent(): boolean {
    // (display only if 'No' selected on the 'Are you the person…' question) and if patient address entered differs from application address
    if (this.baseForm?.model?.form?.tabs?.tab4?.page1?.patientDetails?.areYouThePatient == OPTION_SETS.yesNo.options.no) {
      var addressSection = this.baseForm?.model?.form?.tabs?.tab2?.page1?.address;
      if (addressSection) {
        // check if patient address is also given
        var patientSection = this.baseForm?.model?.form?.tabs?.tab4?.page1?.patientDetails;
        if (patientSection) {
          if (!this.primaryAddressIsManual) {
            return addressSection?.primaryAddress !== patientSection?.patientResidentialAddress
          } else {
            // check manual address
            var primaryAddressManual = {
              streetNumberName: addressSection[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.primaryAddressStreetNumberName],
              suburb: addressSection[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.primaryAddressSuburb],
              state: addressSection[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.primaryAddressState],
            }
            var patientAddressManual = {
              streetNumberName: patientSection[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.patientResidentialAddressStreetNumberName],
              suburb: patientSection[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.patientResidentialAddressSuburb],
              state: patientSection[QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.patientResidentialAddressState]
            }


            return primaryAddressManual.streetNumberName?.trim() !== patientAddressManual.streetNumberName?.trim() ||
              primaryAddressManual.suburb?.trim() !== patientAddressManual.suburb?.trim() ||
              primaryAddressManual.state?.trim() !== patientAddressManual.state?.trim()
          }
        }
      }
    }
    return false;
  }

  private showUploadDocument(): boolean {
    //All (display only if 'Yes' selected to the 'Is this your first time…' question OR if 'Yes' selected to the above question)
    return this.baseForm?.model?.form?.tabs?.tab4?.page1?.patientDetails?.patientFirstTimeApplying == OPTION_SETS.yesNo.options.yes || this.baseForm?.model?.form?.tabs?.tab4?.page1?.patientDetails?.patientMachineChanges == OPTION_SETS.yesNo.options.yes
  }

  private showInstallPeritoneal() {
    return this.baseForm?.model?.form?.tabs?.tab4?.page1?.machineDetails?.peritoneal == OPTION_SETS.yesNo.options.yes;
  }

  private showInstallOxygen() {
    return this.baseForm?.model?.form?.tabs?.tab4?.page1?.machineDetails?.oxygen == OPTION_SETS.yesNo.options.yes;
  }

  private showInstallHaemodialysis() {
    return this.baseForm?.model?.form?.tabs?.tab4?.page1?.machineDetails?.haemodialysis == OPTION_SETS.yesNo.options.yes;
  }

  private registerSaveOnNavigation() {
    this.formNavSubscription =
      this.formNavigationService.onNavigation()
        .pipe(
          bufferTime(200),
          filter(x => x.length > 0)
        ).subscribe(async (data) => {
          this.viewportScroller.scrollToPosition([0, 0]); //Always navigate to the top of the page

          let tabNumber = data.find(x => x.elementType === ElementType.TAB)?.elementNumber
          let pageNumber = data.find(x => x.elementType === ElementType.PAGE)?.elementNumber

          if (this.coreService.isFormEditable === true) {
            // If the user is navigating forwards
            if (tabNumber > this._currentTab || pageNumber > this._currentPage) {

              //introduction confirmation check
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.intro
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.intro) {

                if (!this.selectedApplyForYear) {
                  this.UpdateHeaderAndApplicationPeriod();
                }

                if (this.activeApplications) {
                  // check if there is active application for selected year
                  const selectedApplicationYearApplicationsCount = this.activeApplications
                    .filter(item => item.applicationYear === this.selectedApplyForYear)
                    .map(item => item.count)
                    .find(count => count !== undefined);

                  if (selectedApplicationYearApplicationsCount != null && selectedApplicationYearApplicationsCount > 0) {
                    this.activeDialog = POP_UP_CODES.concessionsApplicationCommon.applicationInProgress;
                    this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.applicationInProgress, null, { applicationYear: this.applicationPeriod }, false);

                    this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                    this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                    return;
                  }
                }
              }

              //check address is in victoria for application
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.applicant
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.applicant) {
                const addressInVic = this.isAddressInVictoria(this.baseForm.model.form.tabs.tab2.page1.address, QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.primaryAddress)
                if (!addressInVic) {
                  this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.invalidResidentialAddress);
                  // prevent navigation away
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                  return;
                }
              }

              //check address is in victoria for patient details
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.patientDetails
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.patientDetails) {
                if (this.baseForm.model.form.tabs.tab4.page1.patientDetails.patientResidentialAddress) {
                  const addressInVic = this.isAddressInVictoria(this.baseForm.model.form.tabs.tab4.page1.patientDetails, QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.patientResidentialAddress)
                  if (!addressInVic) {
                    this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.invalidResidentialAddress);
                    // prevent navigation away
                    this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                    this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                    return;
                  }
                }
              }

              //Machine details single check box validation
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.patientDetails
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.patientDetails) {
                if (!this.checkIfAtleastOneSingleCheckboxSelectedOnMachineDetails()) {
                  this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsLifeSupportForm.machineDetailsValidation);
                  // prevent navigation away
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                  return;
                }
              }

              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.invoice
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationNonMainsLifeSupportForm.invoice) {
                //Invoice confirmation check
                const invoicePage = this.baseForm.model.form.tabs.tab5.page1;
                if (!this.checkSupportingDocCheckboxSelectedOnInvoice(invoicePage.documentInfo)) {
                  this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsLifeSupportForm.checkSupportingDocValidation);
                  // prevent navigation away
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                  return;
                }

                // The user is attempting to navigate away from the invoice page
                // If any of invoice section are expanded, then we want to prevent navigation forwards, and show
                // a popup telling the user they must save their invoice before proceeding.
                const isAnyInvoiceInEditMode = this.checkIfAnyInvoiceIsInEditMode(
                  invoicePage.invoiceInfo,
                  invoicePage.invoiceInfoWater,
                );

                if (isAnyInvoiceInEditMode) {
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);

                  // Show a dialog.
                  this.dialogService.showSimplePopup(POP_UP_TEXTS.common.saveInvoice, POP_UP_HEADER.common.saveInvoice);
                  return;
                }
              }

              // This condition added to avoid calling backend API more than once
              // on component initialization.
              if (this._previousPage !== this._currentPage || this._previousTab !== this._currentTab) {
                this._previousTab = this._currentTab;
                this._previousPage = this._currentPage;
                if (this.isDraftApplication) {
                  this.saveOnNavigation(this.templateId, this.versionNo);
                }
              }
            }
          }

          this._currentTab = tabNumber ?? this._currentTab;
          this._currentPage = pageNumber ?? this._currentTab;
        });
  }


  private checkIfAtleastOneSingleCheckboxSelectedOnMachineDetails(): boolean{

    var machineDetails = this.baseForm?.model?.form?.tabs?.tab4?.page1?.machineDetails;
    if (machineDetails) {
      return _.some(_.values(machineDetails), (value: any) => value === OPTION_SETS.yesNo.options.yes);
    } else {
      return false;
    }
  }

  private onSaveInvoice(itemIndex: number, onComplete: (cancel: boolean) => void): void {
    //check date of invoice
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfo;
    const invoiceSelected = invoiceInfo[itemIndex];

    const invoiceDate = this.parseDateString(invoiceSelected.invoiceDate);
    const applicationPeriodDates = this.baseForm.model.form.tabs.tab5.page1.invoiceUpload.applicationPeriod.split(' to ');
    const fromDate = new Date(applicationPeriodDates[0]);
    const toDate = new Date(applicationPeriodDates[1]);
    // add 30 days to toDate
    toDate.setDate(toDate.getDate() + 30);
    const invoiceDateOk = invoiceDate >= fromDate && invoiceDate <= toDate;

    if (invoiceDateOk) {
      // add the total of invoices
      let invoiceTotal: number = 0;
      invoiceInfo.forEach(item => {
        invoiceTotal = invoiceTotal + parseFloat(item.invoiceAmount);
      });

      this.baseForm.model.form.tabs.tab5.page1.invoiceUpload.invoiceTotal = "$" + invoiceTotal.toFixed(2);
      const fileName = this.extractFileName(invoiceInfo[itemIndex].invoiceDocument);
      invoiceSelected.filename = fileName;
      invoiceSelected.invoiceAmount = this.getInvoiceAmountWithTwoDecimalPlaces(invoiceSelected.invoiceAmount);
      onComplete(false);
    } else {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsLifeSupportForm.invoiceDateValidation);
      onComplete(true);
    }
  }

  private onSaveInvoiceWater(itemIndex: number, onComplete: (cancel: boolean) => void): void {
    //check date of invoice
    const invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoWater;
    const invoiceSelected = invoiceInfo[itemIndex];

    const invoiceDate = this.parseDateString(invoiceSelected.invoiceDateWater);

    const applicationPeriodDates = this.baseForm.model.form.tabs.tab5.page1.invoiceUpload.applicationPeriod.split(' to ');
    const fromDate = new Date(applicationPeriodDates[0]);
    const toDate = new Date(applicationPeriodDates[1]);
    // add 30 days to toDate
    toDate.setDate(toDate.getDate() + 30);
    const invoiceDateOk = invoiceDate >= fromDate && invoiceDate <= toDate;

    if (invoiceDateOk) {
      // add the total of invoices
      let invoiceTotal: number = 0;
      invoiceInfo.forEach(item => {
        invoiceTotal = invoiceTotal + parseFloat(item.invoiceAmountWater);
      });

      this.baseForm.model.form.tabs.tab5.page1.invoiceUploadWater.invoiceTotalWater = "$" + invoiceTotal.toFixed(2);
      const fileName = this.extractFileName(invoiceInfo[itemIndex].invoiceDocumentWater);
      invoiceSelected.filenameWater = fileName;
      invoiceSelected.invoiceAmountWater = this.getInvoiceAmountWithTwoDecimalPlaces(invoiceSelected.invoiceAmountWater);
      onComplete(false);
    } else {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationNonMainsLifeSupportForm.invoiceDateValidation);
      onComplete(true);
    }
  }

  private onBeforeRemoveInvoice(itemIndex, onComplete: (cancel: boolean) => void) {
    let invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfo;
    if (invoiceInfo[itemIndex].invoiceUploadedFromUserPortal === true) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    } else {
      this.dialogService
        .showConfirm(POP_UP_CODES.concessionsApplicationCommon.deleteInvoice)
        .pipe(take(1))
        .subscribe((dialogResult: DialogResult) => {
          if (dialogResult === DialogResult.ACCEPTED) {
            const propertyName = QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.invoiceAmount;
            const formattedInvoiceTotal = this.recalculateInvoiceTotal(itemIndex, invoiceInfo, propertyName)
            this.baseForm.model.form.tabs.tab5.page1.invoiceUpload.invoiceTotal = formattedInvoiceTotal;
            onComplete(false);
          } else {
            onComplete(true);
          }
        });
    }
  }

  private onBeforeRemoveInvoiceWater(itemIndex, onComplete: (cancel: boolean) => void) {
    let invoiceInfo = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceInfoWater;
    if (invoiceInfo[itemIndex].invoiceUploadedFromUserPortal === true) {
      this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.deleteNotAuthorised);
      onComplete(true);
    } else {
      this.dialogService
        .showConfirm(POP_UP_CODES.concessionsApplicationCommon.deleteInvoice)
        .pipe(take(1))
        .subscribe((dialogResult: DialogResult) => {
          if (dialogResult === DialogResult.ACCEPTED) {
            const propertyName = QUESTION_CODES.concessionsApplicationNonMainsLifeSupportForm.invoiceAmountWater;
            const formattedInvoiceTotal = this.recalculateInvoiceTotal(itemIndex, invoiceInfo, propertyName)
            this.baseForm.model.form.tabs.tab5.page1.invoiceUploadWater.invoiceTotalWater = formattedInvoiceTotal;
            onComplete(false);
          } else {
            onComplete(true);
          }
        });
    }
  }

  private showInvoiceElectricitySection(): boolean {
    return this.checkIfAtleastOneSingleCheckboxSelectedOnMachineDetails();
  }

  private showStatDecUploadElectricity(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUpload?.documentType;
    if (docType) {
      return (docType === OPTION_SETS.concessionsDocType.options.statutorydeclaration);
    }
    return false;
  }

  private showInvoiceUploadElectricity(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUpload?.documentType;
    if (docType) {
      const isInvoice = (docType === OPTION_SETS.concessionsDocType.options.invoice);
      if (isInvoice === true) {
        this.baseForm.model.form.tabs.tab5.page1.invoiceUpload.applicationPeriod = this.applicationPeriod;
      }
      return isInvoice;
    }
    return false;
  }

  private showInvoiceWaterSection(): boolean {
    var machineDetails = this.baseForm?.model?.form?.tabs?.tab4?.page1?.machineDetails;
    if (machineDetails) {
      return machineDetails.mainsWater == OPTION_SETS.yesNo.options.no;
    }
    return false;
  }

  private showStatDecUploadWater(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadWater?.documentTypeWater;
    if (docType) {
      return (docType === OPTION_SETS.concessionsDocType.options.statutorydeclaration);
    }
    return false;
  }

  private showInvoiceUploadWater(): boolean {
    var docType = this.baseForm?.model?.form?.tabs?.tab5?.page1?.invoiceUploadWater?.documentTypeWater;
    if (docType) {
      const isInvoice = (docType === OPTION_SETS.concessionsDocType.options.invoice);
      if (isInvoice === true) {
        this.baseForm.model.form.tabs.tab5.page1.invoiceUpload.applicationPeriod = this.applicationPeriod;
      }
      return isInvoice;
    }
    return false;
  }
}
